export const countries = [
  {
    nameAr: 'الأردن',
    cities: [
      'إربد',
      'البلقاء',
      'الزرقاء',
      'الطفيلة',
      'العقبة',
      'الكرك',
      'المفرق',
      'جرش',
      'عجلون',
      'عمان',
      'مادبا',
      'معان',
      'أخرى',
    ],
  },
  {
    nameAr: 'الإمارات',
    cities: [
      'أبوظبي',
      'الشارقة',
      'العين',
      'الفجيرة',
      'أم القيوين',
      'خورفكان',
      'دبا الحصن',
      'دبي',
      'رأس الخيمة',
      'عجمان',
      'أخرى',
    ],
  },
  {
    nameAr: 'البحرين',
    cities: ['الجنوبية', 'الشمالية', 'العاصمة', 'المحرق', 'أخرى'],
  },
  {
    nameAr: 'الجزائر',
    cities: [
      'أدرار',
      'الأغواط',
      'البليدة',
      'البويرة',
      'البيض',
      'الجزائر',
      'الجلفة',
      'الشلف',
      'الطارف',
      'المدية',
      'المسيلة',
      'النعامة',
      'الوادي',
      'اليزي',
      'أم البواقي',
      'باتنة',
      'بجاية',
      'برج بوعريريج',
      'بسكرة',
      'بشار',
      'بومرداس',
      'تبسة',
      'تسمسيلت',
      'تلمسان',
      'تمنراست',
      'تندوف',
      'تيارت',
      'تيبازة',
      'تيزي وزو',
      'جيجل',
      'خنشلة',
      'سطيف',
      'سعيدة',
      'سكيكدة',
      'سوق أهراس',
      'سيدي بلعباس',
      'عنابة',
      'عين الدفلى',
      'عين تموشنت',
      'غرداية',
      'غليزان',
      'قالمة',
      'قسنطينة',
      'مستغانم',
      'معسكر',
      'ميلة',
      'ورقلة',
      'وهران',
      'أخرى',
    ],
  },
  {
    nameAr: 'السعودية',
    cities: [
      'الباحة',
      'الجوف',
      'الحدود الشمالية',
      'الرياض',
      'الشرقية',
      'القصيم',
      'المدينة المنورة',
      'تبوك',
      'جازان',
      'حائل',
      'عسير',
      'مكة المكرمة',
      'نجران',
      'أخرى',
    ],
  },
  {
    nameAr: 'السودان',
    cities: [
      'البحر الأحمر',
      'الجزيرة',
      'الخرطوم',
      'الشمالية',
      'القضارف',
      'النيل الأبيض',
      'النيل الأزرق',
      'جنوب دارفور',
      'جنوب كردفان',
      'سنار',
      'شرق دارفور',
      'شمال دارفور',
      'شمال كردفان',
      'غرب دارفور',
      'غرب كردفان',
      'كسلا',
      'نهر النيل',
      'وسط دارفور',
      'أخرى',
    ],
  },
  {
    nameAr: 'الصومال',
    cities: [
      'أودل',
      'باكول',
      'باي',
      'بري',
      'بنادر',
      'تُقدير',
      'جالجود',
      'جدو',
      'جوبا السفلى',
      'جوبا الوسطى',
      'سناق',
      'سول',
      'شبيلا السفلي',
      'شبيلا الوسطى',
      'مدج',
      'نوجال',
      'هيران',
      'وقويي جالبيد',
      'أخرى',
    ],
  },
  {
    nameAr: 'العراق',
    cities: [
      'أربيل',
      'الأنبار',
      'البصرة',
      'الديوانية',
      'السليمانية',
      'المثنى',
      'النجف',
      'بابل',
      'بغداد',
      'دهوك',
      'ديالي',
      'ذي قار',
      'صلاح الدّين',
      'كربلاء',
      'كركوك',
      'ميسان',
      'نينوى',
      'واسط',
      'أخرى',
    ],
  },
  {
    nameAr: 'الكويت',
    cities: [
      'الأحمدي',
      'الجهراء',
      'العاصمة',
      'الفروانية',
      'حولي',
      'مبارك الكبير',
      'أخرى',
    ],
  },
  {
    nameAr: 'المغرب',
    cities: ['الدار البيضاء', 'الرباط', 'طنجة', 'فاس', 'مراكش', 'أخرى'],
  },
  {
    nameAr: 'اليمن',
    cities: [
      'إب',
      'أبين',
      'البيضاء',
      'الجوف',
      'الحديدة',
      'الضالع',
      'المحويت',
      'المهرة',
      'أمانة العاصمة',
      'تعز',
      'حجة',
      'حضرموت',
      'ذمار',
      'ريمة',
      'شبوة',
      'صعدة',
      'صنعاء',
      'عدن',
      'عمران',
      'لحج',
      'مأرب',
      'أخرى',
    ],
  },
  {
    nameAr: 'تونس',
    cities: [
      'أريانة',
      'القيروان',
      'بن عروس',
      'بنزرت',
      'تطاوين',
      'تونس',
      'زغوان',
      'صفاقس',
      'منوبة',
      'نابل',
      'أخرى',
    ],
  },
  {
    nameAr: 'جزر القمر',
    cities: ['القمر الكبرى', 'أنجوان', 'مايوت', 'موهيلي', 'أخرى'],
  },
  {
    nameAr: 'جيبوتي',
    cities: ['أوجورة', 'تابوك', 'جيبوتي', 'دخيل', 'عرتا', 'علي صبيح', 'أخرى'],
  },
  {
    nameAr: 'سوريا',
    cities: [
      'ادلب',
      'الحسكة',
      'الرقة',
      'السويداء',
      'القنيطرة',
      'اللاذقية',
      'حلب',
      'حماة',
      'حمص',
      'درعا',
      'دمشق',
      'دير الزور',
      'ريف دمشق',
      'طرطوس',
      'أخرى',
    ],
  },
  {
    nameAr: 'عمان',
    cities: [
      'البريمي',
      'الداخلية',
      'الظاهرة',
      'الوسطى',
      'جنوب الباطنة',
      'جنوب الشرقية',
      'شمال الباطنة',
      'شمال الشرقية',
      'ظفار',
      'مسقط',
      'مسندم',
      'أخرى',
    ],
  },
  {
    nameAr: 'فلسطين',
    cities: [
      'أريحا',
      'الخليل',
      'القدس',
      'بيت لحم',
      'جنين',
      'خان يونس',
      'دير البلح',
      'رام الله',
      'رفح',
      'سلفيت',
      'شمال غزة',
      'طوباس',
      'طولكرم',
      'غزة',
      'قلقيلية',
      'نابلس',
      'أخرى',
    ],
  },
  {
    nameAr: 'قطر',
    cities: [
      'الخور',
      'الدوحة',
      'الريان',
      'الشحانية',
      'الشمال',
      'الضعاين',
      'الوكرة',
      'أم صلال',
      'أخرى',
    ],
  },
  {
    nameAr: 'لبنان',
    cities: [
      'البقاع',
      'النبطية',
      'بعلبك الهرمل',
      'بيروت',
      'جبل لبنان',
      'عكّار',
      'لبنان الجنوبي',
      'لبنان الشمالي',
      'أخرى',
    ],
  },
  {
    nameAr: 'ليبيا',
    cities: [
      'البطنان',
      'الجبل الأخضر',
      'الجبل الغربي',
      'الجفارة',
      'الجفرة ',
      'الزاوية',
      'الكفرة ',
      'المرج',
      'المرقب',
      'النقاط الخمس',
      'الواحات ',
      'بنغازي',
      'درنة',
      'سبها ',
      'سرت ',
      'طرابلس ',
      'غات',
      'مرزق ',
      'مصراتة',
      'نالوت',
      'وادي الحياة',
      'وادي الشاطئ',
      'أخرى',
    ],
  },
  {
    nameAr: 'مصر',
    cities: [
      'أسوان',
      'أسيوط',
      'الإسكندرية',
      'الإسماعيلية',
      'الأقصر',
      'البحر الأحمر',
      'البحيرة',
      'الجيزة',
      'الدقهلية',
      'السادس من أكتوبر',
      'السويس',
      'الشارقية',
      'الغربية',
      'الفيوم',
      'القاهرة',
      'القليوبية',
      'المنوفية',
      'المنيا',
      'الوادي الجديد',
      'بني سويف',
      'بورسعيد',
      'جنوب سيناء',
      'حلوان',
      'دمياط',
      'سوهاج',
      'شمال سيناء',
      'قنا',
      'كفر الشيخ',
      'مطروح',
      'أخرى',
    ],
  },
  {
    nameAr: 'موريتانيا',
    cities: [
      'أدرار',
      'البراكنة ',
      'الترارزة',
      'الحوض الشرقي',
      'الحوض الغربي',
      'العصابة',
      'إينشيري',
      'تكانت ',
      'تيرس زمور',
      'داخلة نواذيبو',
      'غيديماغا',
      'كوركول',
      'أخرى',
    ],
  },
];

